import createReducer from '../../utils/createReducer';

const initialState = {
  header: {},
  jumbotron: {},
  footer: {},
  sections: {},
  searchBox: {}
};

export default createReducer(initialState, {});



// WEBPACK FOOTER //
// ./src/universal/redux/modules/content.js